import axiosClient from 'utils/axios';
import { getParamsFormObject } from 'utils';

const endPoint = '/invoices';

export default {
  async getListInvoices(payload) {
    const query = getParamsFormObject(payload);
    const response = await axiosClient.get(`${endPoint}${query}`);
    return response.data;
  },

  async getGlobalInvoices(payload) {
    const query = getParamsFormObject(payload);
    const response = await axiosClient.get(`${endPoint}/global${query}`);
    return response.data;
  },

  async getGlobalInvoiceDetail(payload) {
    let id = payload;
    let query = '';
    if (payload && typeof payload === 'object') {
      id = payload.id;
      const { id: _, ...params } = payload;
      query = getParamsFormObject(params);
    }
    const response = await axiosClient.get(`${endPoint}/global/${id}${query}`);
    return response.data;
  },

  async payGlobalInvoice(id) {
    const response = await axiosClient.put(`${endPoint}/global/${id}/paid`);
    return response.data;
  },

  async getInvoicesDetail(payload) {
    let id = payload;
    let query = '';
    if (payload && typeof payload === 'object') {
      id = payload.id;
      const { id: _, ...params } = payload;
      query = getParamsFormObject(params);
    }
    const response = await axiosClient.get(`${endPoint}/${id}${query}`);
    return response.data;
  },

  async updateInvoiceStatus(id, payload) {
    const response = await axiosClient.put(`${endPoint}/${id}`, payload);
    return response.data;
  },

  async payInvoice(payload) {
    let id = payload;
    let placeId = '';
    if (payload && typeof payload === 'object') {
      id = payload.id;
      placeId = payload.placeId || payload.place || '';
    }
    const query = placeId ? `?place=${placeId}` : '';
    const response = await axiosClient.put(`${endPoint}/${id}/paid${query}`);
    return response.data;
  },

  async exportInvoice(payload) {
    let id = payload;
    let query = '';
    if (payload && typeof payload === 'object') {
      id = payload.id;
      const { id: _, ...params } = payload;
      query = getParamsFormObject(params);
    }
    const response = await axiosClient.get(`${endPoint}/${id}/export${query}`);
    return response.data;
  },
};
